import type { ReactNode } from 'react';
import { Icone, type NomIcone } from './Icone';

/**
 * Bandeau d'alerte (charte, doc 06, § 6.5). Jamais de fenêtre modale :
 * une alerte de granularité BDT est une information quotidienne, pas une
 * interruption.
 *
 * - `gestion`  : situation à arbitrer (ambre) — fréquente, normale
 * - `refus`    : blocage ou rejet (grenat) — anormale
 * - `information` : contexte neutre (Majorelle)
 */
export type NatureAlerte = 'gestion' | 'refus' | 'information';

/** L'icône renforce la sévérité avant même la lecture (charte, doc 06, § 6.5). */
const ICONE: Record<NatureAlerte, NomIcone> = {
  gestion: 'gestion',
  refus: 'refus',
  information: 'information',
};

export function BandeauAlerte({
  nature,
  titre,
  children,
}: {
  nature: NatureAlerte;
  titre: string;
  children: ReactNode;
}) {
  return (
    <div
      className={`bandeau-alerte bandeau-alerte--${nature}`}
      role={nature === 'refus' ? 'alert' : 'status'}
    >
      <Icone nom={ICONE[nature]} taille={20} classe="bandeau-alerte__icone" />
      <div className="bandeau-alerte__corps">
        <span className="surtitre">{titre}</span>
        <p>{children}</p>
      </div>
    </div>
  );
}
